export default __webpack_public_path__ + "media/images/react_icons/spa_pool-39583d5b35cbd7a3577856dbd54e432a.svg";